import { graphql } from '@/gql'

export const GetJobQuery = graphql(/* GraphQL */ `
  query getJob($jobId: ID!) {
    job(id: $jobId) {
      ...Job
    }
  }
`)

export const GetJobFormQuery = graphql(/* GraphQL */ `
  query job($jobId: ID!) {
    job(id: $jobId) {
      ...JobFormData
    }
  }
`)

export const CompanyQuery = graphql(/* GraphQL */ `
  query Company($companyId: ID!) {
    company(id: $companyId) {
      id
      currency
      settings {
        projectTracking
        requiredJobBudget
      }
    }
  }
`)

export const CompanyRecruiters = graphql(/* GraphQL */ `
  query CompanyRecruiters($accounts: [ID!]) {
    companyRecruiters(accounts: $accounts) {
      data {
        id
        status
        recruiterFee
        recruiterOwnershipDays
        recruiterOwnershipDaysLeft
        recruiter {
          id
          name
          avatar
        }
      }
    }
  }
`)

export const TeamMembersAndOwnersQuery = graphql(/* GraphQL */ `
  query TeamMembersAndOwners($companyId: ID!, $first: Int) {
    company(id: $companyId) {
      id
      teamMembersAndOwners(first: $first) {
        data {
          id
          name
          avatar
        }
      }
    }
  }
`)

export const TalentSelectionTrustedContacts = graphql(/* GraphQL */ `
  query TalentSelectionTrustedContacts {
    trustedContacts {
      data {
        id
        worker {
          id
          avatar
          name
          jobTitle
        }
      }
    }
  }
`)
